export default __webpack_public_path__ + "static/ACP-MJCP-3bea64aae4e687d7851901bd8510fc02.png";